export type AdapterOptions = {
  autoCapitalize?: boolean;
};

export const setChangeHandler =
  (onChange: (s: string) => void, { autoCapitalize }: AdapterOptions = { autoCapitalize: false }) =>
  (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
    const {
      target: { value: rawValue },
    } = event;

    return onChange(autoCapitalize ? rawValue?.toUpperCase() : rawValue);
  };
